import React from 'react';
export function HeroSection() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0A0A0A] pt-28" data-id="element-134">
      {/* Real background image — car being painted in spray booth */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/nimjoJ3grqR5xupg1cDe7T/heylloyd-image-1774620623703.png')"
    }} data-id="element-135"></div>
      {/* Dark overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/90 z-0" data-id="element-136"></div>
      <div className="absolute inset-0 bg-hero-pattern opacity-20 z-0" data-id="element-137"></div>

      {/* Glow Effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-red-600/15 rounded-full blur-[120px] z-0 pointer-events-none" data-id="element-138"></div>
      <div className="absolute bottom-0 left-1/4 w-[300px] h-[300px] bg-blue-500/10 rounded-full blur-[100px] z-0 pointer-events-none" data-id="element-139"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-140">
        {/* Main Content */}
        <div className="max-w-4xl" data-id="element-141">
          <div className="mb-6 inline-flex items-center rounded-full border border-red-500/30 bg-red-500/10 px-3 py-1 text-sm font-medium text-red-400 backdrop-blur-sm" data-id="element-142">
            <span className="flex h-2 w-2 rounded-full bg-red-500 mr-2 animate-pulse" data-id="element-143"></span>
            Taller Premium en Madrid
          </div>

          <h1 className="mb-6 text-5xl font-extrabold tracking-tight text-white sm:text-6xl md:text-7xl lg:text-8xl" data-id="element-144">
            <span className="block" data-id="element-145">Especialistas en</span>
            <span className="block animate-shimmer" data-id="element-146">Chapa y Pintura</span>
          </h1>

          <p className="mx-auto mb-10 max-w-2xl text-xl text-gray-300 sm:text-2xl" data-id="element-147">
            Devolvemos la vida y el brillo a tu vehículo con acabados de
            precisión y materiales de la más alta calidad.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-148">
            <a href="#tarifas" className="w-full sm:w-auto inline-flex items-center justify-center rounded-md bg-red-600 px-8 py-4 text-base font-bold text-white shadow-lg hover:bg-red-700 transition-all hover:scale-105 glow-red" data-id="element-149">
              Solicitar presupuesto
            </a>
            <a href="#contacto" className="w-full sm:w-auto inline-flex items-center justify-center rounded-md border-2 border-white/20 bg-white/5 px-8 py-4 text-base font-bold text-white backdrop-blur-sm hover:bg-white/10 hover:border-white/40 transition-all" data-id="element-150">
              Reservar cita
            </a>
          </div>
        </div>

        {/* Floating photo: car being polished/painted */}
        <div className="mt-16 relative w-full max-w-4xl mx-auto animate-float" data-id="element-151">
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent z-10 h-full w-full pointer-events-none rounded-2xl" data-id="element-152"></div>

          {/* Red glow behind the image */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-red-600/20 rounded-full blur-[100px] pointer-events-none" data-id="element-153"></div>

          <img src="https://cdn.magicpatterns.com/uploads/mDYv6S7f26FVPD68uU43UM/heylloyd-image-1774620788369.png" alt="Antes y después — transformación de pintura de coche" className="relative z-[5] w-full h-auto object-cover rounded-2xl shadow-2xl drop-shadow-[0_0_40px_rgba(220,38,38,0.4)] hover:drop-shadow-[0_0_60px_rgba(220,38,38,0.6)] transition-all duration-700 hover:scale-105" style={{
          maxHeight: '420px'
        }} data-id="element-154" />
        </div>
      </div>
    </section>;
}